import { Injectable } from '@angular/core';

import { AuthService } from '../authentication/auth.service.service';
import { Title, Meta } from '@angular/platform-browser';
import { SeoInterface, TagsInterface } from '../../core/interfaces/seo';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
    currentSeo: SeoInterface;
    newSeo: SeoInterface;

    constructor(
        public authService: AuthService,
        private title: Title,
        private meta: Meta
    ) {}

    replaceSeo(): void {
      if (this.currentSeo) {
        this.removeMeta(this.currentSeo);
      }
      this.currentSeo = this.newSeo;
      if (this.newSeo) {
        this.setMeta(this.newSeo);
      } else {
        this.defaultSeo();
      }
    }

    setTitle(title: string): void {
        this.title.setTitle(title);
    }

  setMeta(seo: SeoInterface): void {
    this.setTitle(seo.title);

    seo.tags.forEach(tag => {
      const selector = tag.property ? `property='${tag.property}'` : `name='${tag.name}'`;

      const tagDefinition: any = { content: tag.content };
      if (tag.property) tagDefinition.property = tag.property;
      if (tag.name) tagDefinition.name = tag.name;

      this.meta.updateTag(tagDefinition, selector);
    });
  }

  setSeo(seo: SeoInterface, schemaData?: any): void {
    this.newSeo = seo;
    this.replaceSeo();

    if (schemaData) {
      this.setJsonLd(schemaData);
    }
  }

  private setJsonLd(data: any): void {
    this.removeJsonLd();

    const script = document.createElement('script');
    script.id = 'product-schema';
    script.type = 'application/ld+json';
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
  }

  public removeJsonLd(): void {
    const script = document.getElementById('product-schema');
    if (script) {
      script.remove();
    }
  }

  removeMeta(seo: SeoInterface): void {
    seo.tags.forEach(tag => {
      const selector = tag.property ? `property='${tag.property}'` : `name='${tag.name}'`;
      this.meta.removeTag(selector);
    });
  }

    updateTag(seo: SeoInterface): void {
      for (let i = 0; i < seo.tags.length; i++) {
        this.meta.updateTag({ name: seo.tags[i].name, content: seo.tags[i].content });
      }
    }

    defaultSeo(): void {
      const modelSeo: TagsInterface[] = [{
        name: 'Description',
        content: 'Интернет магазин автозапчастей'
      },
      {
        name: 'Keywords',
        content: 'Автозапчасти'
      }];
      const resultSeo: SeoInterface = {
        title: 'ТирАвто',
        tags: modelSeo
      };
      this.setSeo(resultSeo);
    }
}
